import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { selectDefaultBillingAddress, useSelector } from "@jti/store";
import { AddressInfoBlock, useCountry, useTranslations } from "@jti/ui";
import { useShippingFormContext } from "../../../hooks/useShippingFormContext";
import CustomBillingAddress from "../BillingAddressEditForm";
export const BillingAddressAlternativeDelivery = () => {
    const { __ } = useTranslations();
    const [isEditModeOn, setEditMode] = useState(false);
    const country = useCountry();
    const defaultBillingAddress = useSelector((state) => selectDefaultBillingAddress(state, country));
    const formContext = useShippingFormContext();
    const shouldUseInStoreDeliveryBillingAddress = formContext.getValues("shouldUseInStoreDeliveryBillingAddress");
    const showEditBillingAddressForm = useCallback(() => {
        const populateAddressFields = () => {
            formContext.setValue("billingAddressType", "custom");
            formContext.setValue("billingAddress", {
                ...formContext.getValues("billingAddress"),
                ...defaultBillingAddress,
            });
        };
        if (defaultBillingAddress) {
            populateAddressFields();
        }
        setEditMode(true);
    }, [defaultBillingAddress, formContext]);
    useEffect(() => {
        const isCustomBillingAddress = isEditModeOn || !defaultBillingAddress;
        formContext.setValue("shouldUseInStoreDeliveryBillingAddress", isCustomBillingAddress);
    }, [isEditModeOn, defaultBillingAddress]);
    return (_jsxs(_Fragment, { children: [shouldUseInStoreDeliveryBillingAddress && _jsx(CustomBillingAddress, {}), !shouldUseInStoreDeliveryBillingAddress && defaultBillingAddress && (_jsx(AddressInfoBlock, { address: defaultBillingAddress, editLabel: __("cart.button.edit_billing"), onEdit: showEditBillingAddressForm, hideTelephone: true, isEditable: true }))] }));
};
//# sourceMappingURL=BillingAddressAlternativeDelivery.js.map